import axios from '@/libs/api.request'

export const user = {
  login: (params) => {
    return axios.request({
      url: 'auth/login',
      data: params,
      method: 'post'
    })
  },
  register: (params) => {
    return axios.request({
      url: 'register/register',
      data: params,
      method: 'post'
    })
  },  
  wechatLogin: (params) => {
    return axios.request({
      url: 'user/wechatLogin',
      data: params,
      method: 'post'
    })
  },
  getUserInfo: (params) => {
    return axios.request({
      url: 'user/getUserInfo',
      data: params,
      method: 'post'
    })
  },
  editUserInfo: (params) => {
    return axios.request({
      url: 'user/editUserInfo',
      data: params,
      method: 'post'
    })
  },
  editUserInfo_area: (params) => {
    return axios.request({
      url: 'user/editUserInfo',
      data: params,
      method: 'post'
    })
  },
  sendStationLetter: (params) => {
    return axios.request({
      url: 'user/sendStationLetter',
      data: params,
      method: 'post'
    })
  },
  getLetters: (params) => {
    return axios.request({
      url: 'user/getLetters',
      data: params,
      method: 'post'
    })
  },
  itemList: (params) => {
    return axios.request({
      url: 'user/itemList',
      data: params,
      method: 'post'
    })
  },
  sendLetters: (params) => {
    return axios.request({
      url: 'user/sendLetters',
      data: params,
      method: 'post'
    })
  },
  accountRecordList: (params) => {
    return axios.request({
      url: 'user/accountRecordList',
      data: params,
      method: 'post'
    })
  },
  queryRebateList: (params) => {
    return axios.request({
      url: 'user/queryRebateList',
      data: params,
      method: 'post'
    })
  },  
  editComplain: (params) => {
    return axios.request({
      url: 'user/editComplain',
      data: params,
      method: 'post'
    })
  },   
  complainList: (params) => {
    return axios.request({
      url: 'user/complainList',
      data: params,
      method: 'post'
    })
  },     
  helpList: (params) => {
    return axios.request({
      url: 'user/helpList',
      data: params,
      method: 'post'
    })
  },        
  signOrNot: (params) => {
    return axios.request({
      url: 'user/signOrNot',
      data: params,
      method: 'post'
    })
  }, 
  querySignData: (params) => {
    return axios.request({
      url: 'user/querySignData',
      data: params,
      method: 'post'
    })
  }, 
  sign: (params) => {
    return axios.request({
      url: 'user/sign',
      data: params,
      method: 'post'
    })
  },     
  secretSetting: (params) => {
    return axios.request({
      url: 'user/secretSetting',
      data: params,
      method: 'post'
    })
  },    
  changeLoginPassword: (params) => {
    return axios.request({
      url: 'user/changeLoginPassword',
      data: params,
      method: 'post'
    })
  },    
  changeBankOrCardPassword: (params) => {
    return axios.request({
      url: 'user/changeBankOrCardPassword',
      data: params,
      method: 'post'
    })
  }, 
  queryGameList: (params) => {
    return axios.request({
      url: 'user/queryGameList',
      data: params,
      method: 'post'
    })
  }, 
  queryGameMapList: (params) => {
    return axios.request({
      url: 'user/getGameMapList',
      data: params,
      method: 'post'
    })
  },  
  addmodeAction: (params) => {
    return axios.request({
      url: 'user/addmodeAction',
      data: params,
      method: 'post'
    })
  },      
  getUserModesEdit: (params) => {
    return axios.request({
      url: 'user/getUserModesEdit',
      data: params,
      method: 'post'
    })
  },  
  getUserModesList: (params) => {
    return axios.request({
      url: 'user/getUserModesList',
      data: params,
      method: 'post'
    })
  },        
  delmode: (params) => {
    return axios.request({
      url: 'user/delmode',
      data: params,
      method: 'post'
    })
  },   
  addBetting: (params) => {
    return axios.request({
      url: 'user/addBetting',
      data: params,
      method: 'post'
    })
  },                       
  getUserBettingHistory: (params) => {
    return axios.request({
      url: 'user/getUserBettingHistory',
      data: params,
      method: 'post'
    })
  }, 
  getGameBtnDetailByNum: (params) => {
    return axios.request({
      url: 'user/getGameBtnDetailByNum',
      data: params,
      method: 'post'
    })
  },   
  getGameBtnDetailByPeriod: (params) => {
    return axios.request({
      url: 'user/getGameBtnDetailByPeriod',
      data: params,
      method: 'post'
    })
  },   
  getAutoLastNum: (params) => {
    return axios.request({
      url: 'user/getAutoLastNum',
      data: params,
      method: 'post'
    })
  },   
  getAutoFitSetMode: (params) => {
    return axios.request({
      url: 'user/getAutoFitSetMode',
      data: params,
      method: 'post'
    })
  },   
  doAutoFitEdit: (params) => {
    return axios.request({
      url: 'user/doAutoFitEdit',
      data: params,
      method: 'post'
    })
  },  
  doAutoSetEdit: (params) => {
    return axios.request({
      url: 'user/doAutoSetEdit',
      data: params,
      method: 'post'
    })
  }, 
  getWinTimerInfo: (params) => {
    return axios.request({
      url: 'user/getWinTimerInfo',
      data: params,
      method: 'post'
    })
  },   
  isOpened: (params) => {
    return axios.request({
      url: 'user/isOpened',
      data: params,
      method: 'post'
    })
  },
  queryTodayRankingList: (params) => {
    return axios.request({
      url: 'user/queryTodayRankingList',
      data: params,
      method: 'post'
    })
  }, 
  queryYesterdayRankingList: (params) => {
    return axios.request({
      url: 'user/queryYesterdayRankingList',
      data: params,
      method: 'post'
    })
  },
  gameDetailList: (params) => {
    return axios.request({
      url: 'user/gameDetailList',
      data: params,
      method: 'post'
    })
  },
  rechargeList: (params) => {
    return axios.request({
      url: 'user/rechargeList',
      data: params,
      method: 'post'
    })
  }, 
  redeemApplyList: (params) => {
    return axios.request({
      url: 'user/redeemApplyList',
      data: params,
      method: 'post'
    })
  },
  queryRedeemApplyList: (params) => {
    return axios.request({
      url: 'user/queryRedeemApplyList',
      data: params,
      method: 'post'
    })
  },  
  saveBankAction : (params) => {
    return axios.request({
      url: 'user/saveBankAction',
      data: params,
      method: 'post'
    })
  },
  goodsList: (params) => {
    return axios.request({
      url: 'goods/list',
      data: params,
      method: 'post'
    })
  },
  goodsListDetail: (params) => {
    return axios.request({
      url: 'goods/detail',
      data: params,
      method: 'post'
    })
  },
  rebateDetail: (params) => {
    return axios.request({
      url: 'goods/rebateDetail',
      data: params,
      method: 'post'
    })
  },  
  redeemApply: (params) => {
    return axios.request({
      url: 'user/redeemApply',
      data: params,
      method: 'post'
    })
  },
  toBaseProp : (params) => {
    return axios.request({
      url: 'user/toBaseProp',
      data: params,
      method: 'post'
    })
  },
  toPillProp : (params) => {
    return axios.request({
      url: 'user/toPillProp',
      data: params,
      method: 'post'
    })
  },     
  getLastTzInfo: (params) => {
    return axios.request({
      url: 'user/getLastTzInfo',
      data: params,
      method: 'post'
    })
  },     
  getWinLoseInfo: (params) => {
    return axios.request({
      url: 'user/getMySy',
      data: params,
      method: 'post'
    })
  },  
  receiveRelief: (params) => {
    return axios.request({
      url: 'user/receiveRelief',
      data: params,
      method: 'post'
    })
  },       
  queryFlow: (params) => {
    return axios.request({
      url: 'user/queryFlow',
      data: params,
      method: 'post'
    })
  },  
  sysLogin: (params) => {
    return axios.request({
      url: 'auth/sys/login',
      data: params,
      method: 'post'
    })
  },       
  queryFirstRecharge: (params) => {
    return axios.request({
      url: 'user/queryFirstRecharge',
      data: params,
      method: 'post'
    })
  },    
  getMyAllSy: (params) => {
    return axios.request({
      url: 'user/getMyAllSy',
      data: params,
      method: 'post'
    })
  },        
  queryCashBack: (params) => {
    return axios.request({
      url: 'user/queryCashBack',
      data: params,
      method: 'post'
    })
  },        
  updateCashBack: (params) => {
    return axios.request({
      url: 'user/updateCashBack',
      data: params,
      method: 'post'
    })
  },   
  queryDownList: (params) => {
    return axios.request({
      url: 'user/queryDownList',
      data: params,
      method: 'post'
    })
  },    
  queryWeekLoss: (params) => {
    return axios.request({
      url: 'user/queryWeekLoss',
      data: params,
      method: 'post'
    })
  },  
  updateMbSet: (params) => {
    return axios.request({
      url: 'user/updateMbSet',
      data: params,
      method: 'post'
    })
  },     
  onGetWage: (params) => {
    return axios.request({
      url: 'user/onGetWage',
      data: params,
      method: 'post'
    })
  },  
  getWage: (params) => {
    return axios.request({
      url: 'user/getWage',
      data: params,
      method: 'post'
    })
  },      
  getUseItem: (params) => {
    return axios.request({
      url: 'user/getUseItem',
      data: params,
      method: 'post'
    })
  },    
  drawFirstRecharge: (params) => {
    return axios.request({
      url: 'user/drawFirstRecharge',
      data: params,
      method: 'post'
    })
  },      
  drawFirst: (params) => {
    return axios.request({
      url: 'user/drawFirst',
      data: params,
      method: 'post'
    })
  }, 
  getGameStatus: (params) => {
    return axios.request({
      url: 'user/getGameStatus',
      data: params,
      method: 'post'
    })
  },     
  queryLossBackStatus: (params) => {
    return axios.request({
      url: 'user/queryLossBackStatus',
      data: params,
      method: 'post'
    })
  },  
  queryFirstStatus: (params) => {
    return axios.request({
      url: 'user/queryFirstStatus',
      data: params,
      method: 'post'
    })
  },  
  smsVerify: (params) => {
    return axios.request({
      url: 'user/smsVerify',
      data: params,
      method: 'post'
    })
  },      
  toBeBanker: (params) => {
    return axios.request({
      url: 'user/toBeBanker',
      data: params,
      method: 'post'
    })
  },
  addBettingNiu: (params) => {
    return axios.request({
      url: 'user/addBettingNiu',
      data: params,
      method: 'post'
    })
  },
  queryCanadaNiuRecord: (params) => {
    return axios.request({
      url: 'user/queryCanadaNiuRecord',
      data: params,
      method: 'post'
    })
  }, 
  getUserBettingNiuHistory: (params) => {
    return axios.request({
      url: 'user/getUserBettingNiuHistory',
      data: params,
      method: 'post'
    })
  },    
  queryAgent: (params) => {
    return axios.request({
      url: 'user/queryAgent',
      data: params,
      method: 'post'
    })
  },    
  recharge: (params) => {
    return axios.request({
      url: 'user/recharge',
      data: params,
      method: 'post'
    })
  },
  queryMyRecom: (params) => {
    return axios.request({
      url: 'user/queryMyRecom',
      data: params,
      method: 'post'
    })
  }, 
  saveRecomRate: (params) => {
    return axios.request({
      url: 'user/saveRecomRate',
      data: params,
      method: 'post'
    })
  },     
  drawYesterday: (params) => {
    return axios.request({
      url: 'user/drawYesterday',
      data: params,
      method: 'post'
    })
  },                                     
}



// WEBPACK FOOTER //
// ./src/service/api/user.js